var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.row},[_c('div',{class:_vm.$style.unit},[_vm._t("slot1")],2),_c('div',{class:_vm.$style.unit},[_vm._t("slot2")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }